import createIcon from '../../createIcon';

/**
 * @component @name ElectricBolt
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTQuNjg5OCAyLjIxMDQyTDQuMzI5ODUgMTEuNDkwNEMzLjY4OTg1IDEyLjA3MDQgNC4wNDk4NSAxMy4xNDA0IDQuOTA5ODUgMTMuMjIwNEwxMi45OTk4IDE0LjAwMDRMOC4xNDk4NCAyMC43NjA0QzcuOTI5ODQgMjEuMDcwNCA3Ljk1OTg0IDIxLjUwMDQgOC4yMjk4NCAyMS43NzA0QzguNTI5ODQgMjIuMDcwNCA4Ljk5OTg1IDIyLjA4MDQgOS4zMDk4NSAyMS43OTA0TDE5LjY2OTggMTIuNTEwNEMyMC4zMDk4IDExLjkzMDQgMTkuOTQ5OCAxMC44NjA0IDE5LjA4OTggMTAuNzgwNEwxMC45OTk4IDEwLjAwMDRMMTUuODQ5OCAzLjI0MDQyQzE2LjA2OTggMi45MzA0MiAxNi4wMzk4IDIuNTAwNDIgMTUuNzY5OCAyLjIzMDQyQzE1LjQ2OTggMS45MzA0MiAxNC45OTk4IDEuOTIwNDIgMTQuNjg5OCAyLjIxMDQyWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ElectricBolt = createIcon('ElectricBolt', [
  [
    'path',
    {
      d: 'M14.6898 2.21042L4.32985 11.4904C3.68985 12.0704 4.04985 13.1404 4.90985 13.2204L12.9998 14.0004L8.14984 20.7604C7.92984 21.0704 7.95984 21.5004 8.22984 21.7704C8.52984 22.0704 8.99985 22.0804 9.30985 21.7904L19.6698 12.5104C20.3098 11.9304 19.9498 10.8604 19.0898 10.7804L10.9998 10.0004L15.8498 3.24042C16.0698 2.93042 16.0398 2.50042 15.7698 2.23042C15.4698 1.93042 14.9998 1.92042 14.6898 2.21042Z',
      key: 'b5ozgx',
    },
  ],
]);

export default ElectricBolt;
